var PickupPoint = (function (Backbone) {

	var PickupPoint = Backbone.Model.extend({
		idAttribute: 'ID',

		defaults: {
			selected: false
		},

		select: function (opts) {
			return this.set('selected', true, opts);
		},

		unselect: function (opts) {
			return this.set('selected', false, opts);
		},

		isSelected: function () {
			return this.get('selected');
		},

		toJSONString: function () {
			return JSON.stringify(_.omit(this.attributes, 'selected'));
		}
	});

	return PickupPoint;
})(Backbone);